module.exports = __webpack_public_path__ + "img/school_preview_placeholder.0454d4b.jpg";